import { Component, input } from '@angular/core';

@Component({
  selector: 'onyx-ribbon',
  imports: [],
  templateUrl: './onyx-ribbon.component.html',
  styleUrl: './onyx-ribbon.component.scss',
})
export class OnyxRibbonComponent {
  public readonly marginBottom = input(0);
}
